import { readField } from '../api';

export const toLookupOption = record => {
    const name = readField(record, 'name') || 'Unnamed record';
    return {
        value: readField(record, 'id'),
        label: name,
        guid: readField(record, 'enerexIdentifier') ?? null,
    };
};
